import { Layout } from 'antd'
import styled from 'styled-components'

const { Sider } = Layout;

export const MenuStyle = styled(Sider)`
  background: #fff;
  height: 100%;
  border-right: 1px solid #eee;
  overflow: hidden;
  
  .ant-menu-vertical .ant-menu-item::after, .ant-menu-vertical-left .ant-menu-item::after, .ant-menu-vertical-right .ant-menu-item::after, .ant-menu-inline .ant-menu-item::after{
    right: 1px;
  }
`